import { Link, useNavigate } from "react-router-dom";

export default function GetStarted() {
  const navigate = useNavigate();
  return (
    <div className="bg-white">
      <div className="relative isolate px-6 pt-14 lg:px-8">
        <div className="mx-auto max-w-3xl py-32 sm:py-48 lg:py-56">
          <div className="hidden sm:mb-8 sm:flex sm:justify-center">
            <div className="relative rounded-full px-3 py-1 text-sm leading-6 text-gray-600 ring-1 ring-gray-900/10 hover:ring-gray-900/20">
              Our team is ready to guide, advise, and transform your financial
              landscape..{" "}
              <Link
                target="_blank"
                to={"https://eea-advisory.com.au/about"}
                className="font-semibold text-indigo-600"
              >
                <span className="absolute inset-0" aria-hidden="true" />
                Experience the EEA Difference.{" "}
                <span aria-hidden="true">&rarr;</span>
              </Link>
            </div>
          </div>
          <div className="relative flex justify-center">
            <img className="w-52" src="/logo.svg" alt="Workflow" />
          </div>
          <div className="text-center">
            <h1 className="text-4xl font-bold tracking-tight text-gray-900 sm:text-6xl mt-10">
              Schedule an Appointment with EEA Advisory Today!
            </h1>
            <p className="mt-6 text-lg leading-8 text-gray-600">
              Why wait? With EEA Advisory, you're not just scheduling an
              appointment. You're taking the first step towards innovative,
              tailored financial solutions that elevate your business to the
              next level.
            </p>
            <div className="mt-10 flex items-center justify-center gap-x-6">
              <button
                onClick={() => navigate("/login")}
                className="rounded-md bg-indigo-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
              >
                Get started
              </button>
            </div>
          </div>
        </div>
      </div>
      <p className="text-sm text-gray-500 mt-5 italic w-full text-center">
        Version 1.3.0
      </p>
    </div>
  );
}
